/* tslint:disable:function-name */
var Request = /** @class */ (function () {
    function Request() {
    }
    /**
     * Lookup a query string value by key name
     * @param {string} name the key name you want to lookup
     * @param {string} [url=window.location.href] the url you want to lookup against (defaults to window href)
     * @returns {string|null} the value from the query string or null if not found
     */
    Request.getQueryStringParameter = function (name, url) {
        if (url === void 0) { url = window.location.href; }
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", 'i');
        var results = regex.exec(url);
        if (!results) {
            return null;
        }
        if (!results[2]) {
            return null;
        }
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };
    return Request;
}());
export default Request;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@salecycle/client-script-core/src/api/request.js
// module id = 1
// module chunks = 0